// src/redux/classSlice.js

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  get_enquirytype,
  add_enquirytype,
  update_enquirytype,
  delete_enquirytype,
  get_enquirytype_list,
} from "../Service/ApiServices.js";
import { toast } from "react-toastify";

const initialState = {
  enquirytypes: [],
  enquirytypelist: [],
  school_id: "",
  totalPages: 0,
  pageSize: 10,
  count: 0,
  activePage: 1,
  loading: false,
  error: null,
  addLoading: false,
  IsEditing: false,
  formData: {
    name: "",
    description: "",
  },
};

// Async Thunks for API Calls
export const fetchenquirytypelist = createAsyncThunk(
    "enquirytype/fetchenquirytypelist",
    async (
      { school_id, token, signal },
      { rejectWithValue }
    ) => {
      try {
        const response = await get_enquirytype_list(
        
          school_id,
        
          token,
          signal
        );
        if (response.status) {
          return response.response;
        } else {
          return rejectWithValue(response.response.message);
        }
      } catch (error) {
        return rejectWithValue(error.message);
      }
    }
  );
// Async Thunks for API Calls
export const fetchenquirytype = createAsyncThunk(
  "enquirytype/fetchenquirytype",
  async (
    { page, page_size, school_id,status, token, signal },
    { rejectWithValue }
  ) => {
    try {
      const response = await get_enquirytype(
        page,
        page_size,
        school_id,
        status,
        token,
        signal
      );
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response.message);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
export const createenquirytype = createAsyncThunk(
  "enquirytype/createenquirytype",
  async ({ data, school_id, token, signal }, { rejectWithValue }) => {
    try {
      const response = await add_enquirytype(data, school_id, token, signal);
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response.message);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
export const updateenquirytype = createAsyncThunk(
  "enquirytype/updateenquirytype",
  async ({ data, token, signal }, { rejectWithValue }) => {
    try {
      const response = await update_enquirytype(data, token, signal);
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response.message);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const deleteenquirytype = createAsyncThunk(
  "enquirytype/deleteenquirytype",
  async ({ ids, token, signal }, { rejectWithValue }) => {
    try {
      const response = await delete_enquirytype({ ids }, token, signal);
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response.message);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
// Class Slice
const enquirytypeSlice = createSlice({
  name: "enquirytypes",
  initialState,
  reducers: {
    setActivePage(state, action) {
      state.activePage = action.payload;
    },
    updateFormData(state, action) {
      const { name, value } = action.payload;
      state.formData[name] = value;
    },
    EditFormData(state, action) {
      const { id, name,description } = action.payload;
      state.formData = { id,  name,description   };
    },
    resetFormData(state) {
      state.formData = {
        name: "",
        description: "",
      };
    },
    setenquirytype(state, action) {
      state.enquirytypes = action.payload;
    },
    setIsEditing(state, action) {
      state.IsEditing = action.payload;
    },
    setPageSize(state, action) {
      state.pageSize = action.payload;
    },
    setSchoolId(state, action) {
      state.school_id = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchenquirytypelist.fulfilled, (state, action) => {
        console.log()
        state.enquirytypelist = action.payload.data;
      })
      .addCase(fetchenquirytypelist.rejected, (state, action) => {
        state.enquirytypelist = [];

      })
      // Fetch Classes
      .addCase(fetchenquirytype.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchenquirytype.fulfilled, (state, action) => {
        state.loading = false;
        state.enquirytypes = action.payload.results;
        state.count = action.payload.count;
        state.totalPages = Math.ceil(action.payload.count / state.pageSize);
      })
      .addCase(fetchenquirytype.rejected, (state, action) => {
        state.loading = false;
        state.enquirytypes = [];
      })

      // Add Class
      .addCase(createenquirytype.pending, (state) => {
        state.addLoading = true;
      })
      .addCase(createenquirytype.fulfilled, (state, action) => {
        state.addLoading = false;
        state.enquirytypes = action.payload.data;
        state.IsEditing = false;
        toast.success(action.payload.message || "Something went wrong!");
      })
      .addCase(createenquirytype.rejected, (state, action) => {
        state.addLoading = false;
        state.error = action.payload;
        toast.info(action?.payload?.message || "Something went wrong!");
        state.IsEditing = false;
      })
      // Update Class
      .addCase(updateenquirytype.pending, (state) => {
        state.addLoading = true;
      })
      .addCase(updateenquirytype.fulfilled, (state, action) => {
        state.addLoading = false;
        state.IsEditing = false;

        toast.success(action?.payload?.message || "Something went wrong!");
      })
      .addCase(updateenquirytype.rejected, (state, action) => {
        state.addLoading = false;
        state.error = action.payload;
        state.IsEditing = false;

        toast.info(action?.payload?.message || "Something went wrong!");
      })
      // Delete Class
      .addCase(deleteenquirytype.pending, (state) => {
        state.loading = true;
      })
      .addCase(deleteenquirytype.fulfilled, (state, action) => {
        state.loading = false;
        toast.success(action?.payload?.message || "Something went wrong!");
      })
      .addCase(deleteenquirytype.rejected, (state, action) => {
        state.loading = false;
        toast.info(action?.payload?.message || "Something went wrong!");
        state.error = action.payload;
      });
  },
});

// Export the actions and the reducer
export const {
  setenquirytype,
  setActivePage,
  updateFormData,
  EditFormData,
  resetFormData,
  setIsEditing,
  setSchoolId,
  setPageSize,
} = enquirytypeSlice.actions;
export default enquirytypeSlice.reducer;
